





















import Vue from "vue";
import { Component, Watch } from "vue-property-decorator";
import { Action, Getter } from "vuex-class";
import { AppConstants as _app } from "@/shared/app.constants";

@Component
export default class ApplicantDeclarationComponent extends Vue {
  @Action("createApplication", { namespace: "application" }) createApplication: any;
  @Action("setApplication", { namespace: "application" }) setApplication: any;
  @Action("setCallId", { namespace: "application" }) setCall: any;
  @Getter("callId", { namespace: "application" }) callId: number;
  checkboxValue: boolean = true;
  declarationContent = _app.applicantDeclarationText;
  programId: number;

  /** mount fn */
  mounted() {
    /** get the query string to manage the redirection from login screen */
    if (this.$route.query.callId) {
      this.setCall(this.$route.query.callId);
    }

    if (this.$route.query.programid) {
      this.programId = parseInt(this.$route.query.programid.toString());
    }

    /** if call id is not set, redirect to the calls listing page */
    if (!this.callId) {
      this.$router.push({
        name: "callForProposal"
      });
    }

    this.$forceUpdate();
  }

  /** submit declaration */
  declarationSubmit() {
    if (this.callId) {
      // create new application and navigate to the application form
      return this.createApplication(this.callId)
        .then((id: any) => {
          if (id != null) {
            this.$router.push({
              name: "applicantapply",
              params: { applicationId: id }
            });
          }
        });
    }
  }

  declarationDisagree() {
    const key: any = "appDeclaration";
    this.$router.push({
      name: "genericNotification",
      query: { msgId: key },
    });
  }

  @Watch("$route", { immediate: true, deep: true })
  onUrlChange(changedRoute: any) {
    if (changedRoute.name === "ApplicantDeclaration" && changedRoute.params && changedRoute.params.programid) {
      this.programId = parseInt(changedRoute.params.programid)
      this.$forceUpdate();
    }
  }
}
